import { DeleteModal, DeleteModalProps, Modal } from "@app/components/modals"
import { ModalInstance } from "@app/hooks/useModal"
import { IKitchenArea } from "@app/common";

interface KitchenAreaDeleteModalProps extends ModalInstance<IKitchenArea>, Omit<DeleteModalProps<IKitchenArea>, 'children'> {
  onDelete: (kitchenArea: Partial<IKitchenArea>) => void;
}

export const KitchenAreaDeleteModal = (props: KitchenAreaDeleteModalProps) => {
  return (
    <DeleteModal {...props} >
      <Modal.Subtitle>Vous allez supprimer un lieu de production.</Modal.Subtitle>
      <Modal.Message>
        Cette suppression est irréversible.
      </Modal.Message>
    </DeleteModal>
  )
}